module.exports = __webpack_public_path__ + "asset/board-minutes-form--989e54.png";